import React, { useEffect, useState } from "react";
import "../../../../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  displayCommaFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import { useDispatch, useSelector } from "react-redux";
import {
  setDocViewTableData,
  setSelectedNotInPR,
  setSelectedRowNotInPr,
} from "containers/gstr2a2bNewEnhancement/Reconciliation/action";
import ReactPaginate from "react-paginate";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import UserComment from "../UserComment";
// let tableData = [
//   { id: "1", gstin: "1234567" },
//   { id: "2", gstin: "ABCD" },
// ];

const Table = (props) => {
  const dispatch = useDispatch();
  const {
    selectedNotInPR,
    docViewTableData,
    totalPageNotInPr,
    selectedRowNotInPR,
    pageNoNotInPr
  } = useSelector((store) => store.gstr2a2bNewRecoReducer);
  const [open, setOpen] = useState(false);
  const [commentRow, setCommentRow] = useState([]);

  const userCommentsFormatter = (cell, row) => {
    return (
      <div
        style={{
          width: "100%",
          cursor: "pointer",
          textDecoration: "underline",
          color: "#4f2d7f",
        }}
        onClick={() => {
          console.log("row::", row.TXN_ID);
          setCommentRow(row);
          setOpen(true);
        }}
      >
        {"Link"}
      </div>
    );
  };
  
  const handleCloseComment = () => {
    setOpen(false);
    setCommentRow([]);
  };
  const columns = [
    {
      dataField: "ORIGINAL_MATCH_TYPE",
      text: "Original Match Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) =>
        displayNullFormatter(row, "ORIGINAL_MATCH_TYPE"),
    },
    {
      dataField: "GSTIN_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN_PURCHASE"),
    },
    {
      dataField: "GSTIN",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN"),
    },
    {
      dataField: "CTIN_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_PURCHASE"),
    },
    {
      dataField: "CTIN_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_SALE"),
    },
    {
      dataField: "INUM_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INUM_PURCHASE"),
    },
    {
      dataField: "INUM_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INUM_SALE"),
    },
    {
      dataField: "IDT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "IDT_PURCHASE"),
    },
    {
      dataField: "IDT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "IDT_SALE"),
    },
    {
      dataField: "POS_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "POS_PURCHASE"),
    },
    {
      dataField: "POS_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "POS_SALE"),
    },
    {
      dataField: "TXVAL_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_PURCHASE"),
    },
    {
      dataField: "TXVAL_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_SALE"),
    },
    {
      dataField: "IAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "IAMT_PURCHASE"),
    },
    {
      dataField: "IAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "IAMT_SALE"),
    },
    {
      dataField: "CAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CAMT_PURCHASE"),
    },
    {
      dataField: "CAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CAMT_SALE"),
    },
    {
      dataField: "SAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "SAMT_PURCHASE"),
    },
    {
      dataField: "SAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "SAMT_SALE"),
    },
    {
      dataField: "CSAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CSAMT_PURCHASE"),
    },
    {
      dataField: "CSAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CSAMT_SALE"),
    },
    {
      dataField: "RETURN_PERIOD",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RETURN_PERIOD"),
    },
    {
      dataField: "RET_PERIOD",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RET_PERIOD"),
    },
    {
      dataField: "GSTR2B_PERIOD",
      text: "GSTR-2B Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTR2B_PERIOD"),
    },
    {
      dataField: "Report24",
      text: "Matched Month",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "Report24"),
    },
    {
      dataField: "ITC_AVAILABILITY",
      text: "ITC Availability as per 2B",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ITC_AVAILABILITY"),
    },
    {
      dataField: "ITC_UNAVAILABILITY_REASON",
      text: "ITC Un-availability as per 2B reason",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ITC_UNAVAILABILITY_REASON"),
    },
    {
      dataField: "Report30",
      text: "User Comments",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "2.8%",
      },
      // formatter: (cell, row) => displayNullFormatter(row, "Report30"),
      formatter: userCommentsFormatter,
    },
  ];
  // const columns = [
  //   {
  //     dataField: "Original Match Type",
  //     text: "Original Match Type",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },

  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "PR",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTN",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "GSTR-2B Period",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "Matched Month",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "ITC Availability as per 2B",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  //   {
  //     dataField: "Report",
  //     text: "ITC Un-availability as per 2B reason",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "3.6%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },

  //   {
  //     dataField: "Report",
  //     text: "User Comments",
  //     style: (cell, row, rowIndex, colIndex) => ({
  //       ...commonStyle,
  //     }),
  //     headerStyle: {
  //       ...commonHeaderStyle,
  //       width: "2.8%",
  //     },
  //     formatter: (cell, row) => displayNullFormatter(row, "gstin"),
  //   },
  // ];
  function handleOnSelect(row, isSelect) {
    if (isSelect) {
      dispatch(setSelectedNotInPR([...selectedNotInPR, row.TXN_ID]));
      dispatch(setSelectedRowNotInPr([...selectedRowNotInPR, row]));
    } else {
      const updatedNotInPr = selectedNotInPR.filter((id) => id !== row.TXN_ID);
      dispatch(setSelectedNotInPR(updatedNotInPr));

      const updatedRows = selectedRowNotInPR.filter(
        (r) => r.TXN_ID !== row.TXN_ID
      );
      dispatch(setSelectedRowNotInPr(updatedRows));
    }
  }

  function handleOnSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.TXN_ID);
    if (isSelect) {
      dispatch(setSelectedNotInPR(ids));
      dispatch(setSelectedRowNotInPr(rows));
    } else {
      dispatch(setSelectedNotInPR([]));
      dispatch(setSelectedRowNotInPr([]));
    }
  }
  const selectRow = {
    mode: "checkbox",
    selected: selectedNotInPR,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    headerColumnStyle: {
      width: "37px",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "37px",
      textAlign: "center",
    },
  };


  useEffect(() => {
    return () => {
      dispatch(setSelectedNotInPR([]));
      dispatch(setDocViewTableData([]));
    };
  }, []);

  useEffect(() => {
    console.log("selectedNotInPR", selectedNotInPR);
    console.log("selectedRowNotInPR", selectedRowNotInPR);
  }, [selectedNotInPR, selectedRowNotInPR]);

  return (
    <>
      {docViewTableData?.length > 0 ? (
        <>
          {" "}
          <div
            id="tableDiv-scroll"
            className="light-border-gstr2a2bnew-table"
            style={{ maxHeight: "500px" }}
          >
            <div
              style={{
                display: "flex",
                width: "450%",
              }}
            >
              <div style={{ backgroundColor: "#4F2D7F", width: "4.4%" }}></div>
              <div
                className="gstr2a2bnew-header-div"
                style={{
                  width: "7.2%",
                }}
              >
                Recipient GSTIN
              </div>
              <div
                className="gstr2a2bnew-header-div"
                style={{
                  width: "7.2%",
                }}
              >
                Supplier GSTIN
              </div>
              <div
                className="gstr2a2bnew-header-div"
                style={{
                  width: "7.2%",
                }}
              >
                Document Number
              </div>

              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                Document Date
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                POS
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                Taxable Value
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                IGST
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                CGST
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                SGST
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                CESS
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                Tax Period
              </div>
              <div
                className="gstr2a2bnew-header-div"
                style={{ width: "16.4%" }}
              ></div>
            </div>

            <BootstrapTable
              keyField="TXN_ID"
              data={docViewTableData}
              columns={columns}
              rowStyle={rowStyle2}
              selectRow={selectRow}
            />
          </div>
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPageNotInPr}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={pageNoNotInPr > 0 ? pageNoNotInPr - 1 : 0}
                
          />
        </>
      ) : (
        <NoData />
      )}
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="sm"
        open={open}
      >
        <MuiDialogTitle
          disableTypography
          style={{ color: "#4f2d7f", backgroundColor: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Typography variant="h6">{"User Comment"}</Typography>
            <CloseIcon
              onClick={handleCloseComment}
              style={{ cursor: "pointer" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <div>
            <UserComment commentRow={commentRow} handleSubmit={props.handleSubmit} handleCloseComment={handleCloseComment}/>
          </div>
        </MuiDialogContent>
      </Dialog>
    </>
  );
};

export default Table;
